import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone, Mail } from 'lucide-react';
import { Button } from './ui/button';
import { companyInfo } from '../data/mock';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Startseite', href: '/' },
    { name: 'Leistungen', href: '/leistungen' },
    { name: 'Unsere Werte', href: '/werte' },
    { name: 'Arbeitsweise', href: '/arbeitsweise' },
    { name: 'Kontakt', href: '/kontakt' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      {/* Top Bar */}
      <div className="bg-forest-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-end items-center h-10 text-sm">
            <div className="flex items-center gap-6">
              <a href={`tel:${companyInfo.phone}`} className="flex items-center gap-2 hover:text-forest-200 transition-colors">
                <Phone className="h-4 w-4" />
                <span className="hidden sm:inline">{companyInfo.phone}</span>
              </a>
              <a href={`mailto:${companyInfo.email}`} className="flex items-center gap-2 hover:text-forest-200 transition-colors">
                <Mail className="h-4 w-4" />
                <span className="hidden sm:inline">{companyInfo.email}</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <div className="h-12 flex items-center flex-shrink-0">
              <img 
                src="/ZihniLogoNeu.png" 
                alt="Logo"
                className="h-12 w-auto object-contain"
              />
            </div>
            <div className="flex flex-col">
              <div className="text-forest-900 font-bold text-sm sm:text-base lg:text-lg leading-tight">{companyInfo.name}</div>
              <div className="text-gray-600 text-xs">{companyInfo.slogan}</div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-1">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
                  isActive(item.href)
                    ? 'text-forest-700 bg-forest-50'
                    : 'text-gray-700 hover:text-forest-700 hover:bg-gray-50'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          {/* CTA Button Desktop */}
          <div className="hidden lg:block">
            <Link to="/kontakt">
              <Button className="bg-forest-600 hover:bg-forest-700 text-white">
                Termin vereinbaren
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <button
            type="button"
            className="lg:hidden p-2 rounded-md text-gray-700 hover:bg-gray-100"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col gap-2">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setMobileMenuOpen(false)}
                  className={`px-4 py-3 rounded-md text-sm font-medium transition-colors ${
                    isActive(item.href)
                      ? 'text-forest-700 bg-forest-50'
                      : 'text-gray-700 hover:bg-gray-50'
                  }`}
                >
                  {item.name}
                </Link>
              ))}
              <Link to="/kontakt" onClick={() => setMobileMenuOpen(false)} className="mt-2">
                <Button className="w-full bg-forest-600 hover:bg-forest-700 text-white">
                  Termin vereinbaren
                </Button>
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};
